import { render } from "./Moniteur.vue?vue&type=template&id=36342ff2&scoped=true"
import script from "./Moniteur.vue?vue&type=script&lang=js"
export * from "./Moniteur.vue?vue&type=script&lang=js"

import "./Moniteur.vue?vue&type=style&index=0&id=36342ff2&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36342ff2"]])

export default __exports__